export default __webpack_public_path__ + "static/media/data.4d3588b8.svg";